import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import Draggable from 'react-draggable';
import { translate } from 'react-i18next';

import { theme } from 'lib/styles';

import {
	Container,
	Label,
	PositionContainer,
	HandleWrapper,
	Handle,
	GrabIcon,
} from './styles';

const HandleWithIcon = ({ position }) => {
	return (
		<Handle>
			<GrabIcon className="icon" icon="dots-horizontal-triple" />
			<GrabIcon className="icon" icon="dots-horizontal-triple" />
		</Handle>
	)
}

HandleWithIcon.propTypes = {
	position: PropTypes.arrayOf(PropTypes.number),
}

const Position = props => {
	const { t } = props;
	const position = {
		x: props.position[0],
		y: props.position[1]
	};
	const defaultPosition = {
		x: position.x * 2.18,
		y: position.y * 2.18,
	}

	return (
		<ThemeProvider theme={theme}>
			<Container>
				<Label>{t('controls/image/position/label', { ...position })}</Label>
				<PositionContainer>
					<HandleWrapper>
						<Draggable
							bounds="parent"
							onDrag={(e, d) => {
								const parent = d.node.parentElement;
								const offsetSize = parent.offsetHeight;
								const size = d.node.offsetHeight;
								const maxSize = offsetSize - size;
								const x = Math.max(0, Math.min(100, Math.round((d.x / maxSize) * 100)));
								const y = Math.max(0, Math.min(100, Math.round((d.y / maxSize) * 100)));

								props.changesHandler({ position: [ x, y ] });
							}}
							position={defaultPosition}
						>
							<div style={{display: 'inline-block', width: '48px', height: '48px'}}>
								<HandleWithIcon />
							</div>
						</Draggable>
					</HandleWrapper>
				</PositionContainer>
			</Container>
		</ThemeProvider>
	)
}

Position.propTypes = {
	t: PropTypes.func,
	position: PropTypes.arrayOf(PropTypes.number),
	changesHandler: PropTypes.func,
}

export default translate('translations')(Position)
